import styled, { css } from 'styled-components';

const tableHeaderBaseStyles = css`
  margin-block-start: 1.5rem;
  margin-block-end: 1rem;
  margin-inline: 0;
  width: 100%;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const SubSectionTitleHeader = styled.h4<{
  $isBKBrand?: boolean;
  $isBKDEAndGermanLegalRequirement?: boolean;
}>`
  ${tableHeaderBaseStyles};
  border-block-end: ${props => {
    if (props?.$isBKDEAndGermanLegalRequirement) {
      return 'none';
    }
    const color = props?.$isBKBrand ? Styles.color.grey.five : Styles.color.grey.four;
    return `1px solid ${color}`;
  }};
`;

export const ItemTitleHeader = styled.h5<{ $isBKBrand?: boolean }>`
  ${tableHeaderBaseStyles};
  border-block-end: ${({ $isBKBrand }) =>
    `1px solid ${$isBKBrand ? Styles.color.grey.five : Styles.color.grey.four}`};
`;
